const BaseComponent = require('base/base-component');

class Footer extends BaseComponent {
  init () {
    this.$el.find('.find-error-sh a').on('click', () => {
      const location = window.location.href;
      window.open(`http://121.43.68.40/exposure/jiucuo.html?site_code=4508000016&url=${location}`);
    });
  }
}

module.exports = Footer;
